export default __webpack_public_path__ + "static/media/books-768w.44f70588.webp";